
import { useEffect, useState } from "react";
import { 
  insertDemoMultiSelectQuestion, 
  insertDemoDragDropGame, 
  insertDemoLinkingGame, 
  insertDemoFreeResponseQuestions 
} from "./insertDemoQuestion";

interface InitializeDemoQuestionProps {
  resourceId?: string;
}

export function InitializeDemoQuestion({ resourceId }: InitializeDemoQuestionProps) {
  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function addDemoContent() {
      try {
        if (!initialized && resourceId) {
          // Add the multiple select quiz question
          await insertDemoMultiSelectQuestion();
          
          // Add the drag and drop game
          await insertDemoDragDropGame(resourceId);
          
          // Add the linking game
          await insertDemoLinkingGame(resourceId);
          
          // Add free response questions
          await insertDemoFreeResponseQuestions(resourceId);
          
          setInitialized(true);
        }
      } catch (err) {
        console.error("Failed to initialize demo content:", err);
        setError("Failed to add demo content");
      }
    }

    addDemoContent();
  }, [initialized, resourceId]);

  // This component doesn't render anything
  return null;
}
